import { Menu } from '@headlessui/react'
import { useState, useEffect } from 'react'
import { daysInMonth, rellenar } from '../utils/calendar.utils'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Calendar({ indiceDia, setIndiceDia, mes:mesParam, ciclo, nombreMes, data, reporteDatos, verModalSeguro, setListaFaltas }) {

  const [days, setDays] = useState([])
  const [totalDays, setTotalDays] = useState(0)

  const handleClick = (events, dateIndex) => {
    setListaFaltas(() => []);
    setTimeout(() => setListaFaltas(() => events), 25)
    setIndiceDia(dateIndex)
  }
  
  useEffect(() => {
    setTotalDays(daysInMonth(mesParam, ciclo))
  }, [mesParam]) // ejecucion al cambiar de mes

  useEffect(() => {
  }, [totalDays]) // seteo de los días
  
  useEffect(() => {
    if(totalDays){
      setDays(rellenar(mesParam, ciclo, totalDays, data))
    }
  }, [reporteDatos])
  
  return (
    <div className="flex flex-col">
      <header className="flex items-center justify-between border-primarioMira /px-6 /py-4 lg:flex-none">
        <h1 className="text-base font-semibold leading-6 text-gray-900">
          <h1 className='text-gray-100 text-xl mb-2'>{`${nombreMes} ${ciclo}`}</h1>
        </h1>
      </header>
      
        <div className="bg-gray-700 border flex flex-row w-full font-medium text-gray-100 rounded-t-md ">
          <div className="py-2 flex w-1/6 text-center">
              <p className='mx-auto'>Lunes</p>
          </div>
          <div className="py-2 flex w-1/6 text-center">
              <p className='mx-auto'>Martes</p>
          </div>
          <div className="py-2 flex w-1/6 text-center">
              <p className='mx-auto'>Miércoles</p>
          </div>
          <div className="py-2 flex w-1/6 text-center">
              <p className='mx-auto'>Jueves</p>
          </div>
          <div className="py-2 flex w-1/6 text-center">
              <p className='mx-auto'>Viernes</p>
          </div>
          <div className="py-2 flex w-1/6 text-center">
              <p className='mx-auto'>Sábado</p>
          </div>
          <div className="py-2 flex w-1/6 text-center">
              <p className='mx-auto'>Domingo</p>
          </div>
        </div>
        <div className="grid grid-cols-7">
            {days.length > 0 && days.map(e => (
                  <div className={classNames(e.dateIndex ?'bg-primarioMira':'bg-gray-800','gap-2 flex flex-col  border border-gray-500 justify-between hover:border-gray-50 hover:border-2 transition duration-200 ease hover:scale-110')}>
                      <div className={'flex flex-row'}>
                        {e.dateIndex && (
                          <div className={classNames(e.events?.length>0?'bg-azulBrillanteMira cursor-pointer /box3 h-full w-full ':'','flex flex-col p-2')}
                            onClick={() => handleClick(e.events, e.dateIndex)}>
                              <span className={classNames(e.dateIndex === indiceDia?"bg-secundario text-gray-800 font-medium":"bg-azulBrillanteMira","text-center h-6 w-6 rounded-full text-gray-100 transition duration-250")}>{e.dateIndex}</span>
                          </div>
                        )}
                      </div>
                  </div>
            ))}
        </div>
    </div>
  )
}
